import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classnames from 'classnames';
import { Component, createRef } from '@wordpress/element';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import Spinner from '../spinner';
/**
 * WebPreview component to display an iframe of another page.
 */

var WebPreview =
/*#__PURE__*/
function (_Component) {
  _inherits(WebPreview, _Component);

  function WebPreview(props) {
    var _this;

    _classCallCheck(this, WebPreview);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WebPreview).call(this, props));
    _this.state = {
      isLoading: true
    };
    _this.iframeRef = createRef();
    _this.setLoaded = _this.setLoaded.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WebPreview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.iframeRef.current.addEventListener('load', this.setLoaded);
    }
  }, {
    key: "setLoaded",
    value: function setLoaded() {
      this.setState({
        isLoading: false
      });
      this.props.onLoad();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          loadingContent = _this$props.loadingContent,
          src = _this$props.src,
          title = _this$props.title;
      var isLoading = this.state.isLoading;
      var classes = classnames('woocommerce-web-preview', className, {
        'is-loading': isLoading
      });
      return createElement("div", {
        className: classes
      }, isLoading && loadingContent, createElement("div", {
        className: "woocommerce-web-preview__iframe-wrapper"
      }, createElement("iframe", {
        ref: this.iframeRef,
        title: title,
        src: src
      })));
    }
  }]);

  return WebPreview;
}(Component);

WebPreview.propTypes = {
  /**
   * Additional class name to style the component.
   */
  className: PropTypes.string,

  /**
   * Content shown when iframe is still loading.
   */
  loadingContent: PropTypes.node,

  /**
   * Function to fire when iframe content is loaded.
   */
  onLoad: PropTypes.func,

  /**
   * Iframe src to load.
   */
  src: PropTypes.string.isRequired,

  /**
   * Iframe title.
   */
  title: PropTypes.string.isRequired
};
WebPreview.defaultProps = {
  loadingContent: createElement(Spinner, null),
  onLoad: noop
};
export default WebPreview;
//# sourceMappingURL=index.js.map